<template>
  <section class="landing-page-employers">
    <PublicNavigation />
    <div class="main-header">
      <div class="center-text">
        <div class="text">
          <img :src="require(`../../../public/img/landing-pages/Jobshark_light.png`)" />
          <h1>
            Advance Your Career with Jobshark
          </h1>
        </div>
      </div>
    </div>
    <div class="content-section-gray">
      <div class="container">
        <div class="content">
          <h2>
            Join the new IT community and
            <span>Connect with Top Companies Today!</span>
          </h2>
          <span class="orange"
            >Accelerate your skillset, <span>career growth, and well-being! </span></span
          >
          <div class="d-flex" style="justify-content: center;margin-bottom: 50px;">
            <button id="register-btn" @click="openModal" class="btn btn-secondary">
              JOIN NOW!
            </button>
          </div>
        </div>
      </div>
    </div>
    <section class="statistics">
      <div class="container">
        <div class="content">
          <h2 class="text-center">Top Jobs from Leading Companies</h2>
          <section class="brands">
            <carousel
              :autoplay="true"
              :nav="false"
              :items="4"
              :margin="40"
              :responsive="{
                0: { items: 2, nav: false },
                576: { items: 3, nav: false },
                768: { items: 3, nav: false },
                992: { items: 4, nav: false },
                1200: { items: 5, nav: false },
              }"
            >
              <img
                v-for="brand in brands"
                :key="brand.id"
                class="lgx-logo-img"
                :src="require(`../../../public/img/homepage/customer-logos/${brand.src}`)"
                style="max-width: 350px; max-height: 350px"
                :alt="brand.alt"
                :title="brand.alt"
              />
            </carousel>
          </section>
        </div>
      </div>
    </section>
    <!--     <div class="stats">
      <div class="d-flex">
        <div class="info-col">
          <span>34</span>
          <h2>Backend <span>Development</span></h2>
          <ul class="list-unstyled">
            <li>Java</li>
            <li>.NET</li>
          </ul>
        </div>
        <div class="info-col">
          <span>29</span>
          <h2>Frontend <span>Development</span></h2>
          <ul class="list-unstyled">
            <li>Java</li>
            <li>.NET</li>
          </ul>
        </div>
        <div class="info-col">
          <span>68</span>
          <h2>Quality <span>Assurance</span></h2>
          <ul class="list-unstyled">
            <li>Java</li>
            <li>.NET</li>
          </ul>
        </div>
        <div class="info-col">
          <span>23</span>
          <h2>Mobile <span>Development</span></h2>
          <ul class="list-unstyled">
            <li>Java</li>
            <li>.NET</li>
          </ul>
        </div>
        <div class="info-col">
          <span>54</span>
          <h2>Data <span>Science</span></h2>
          <ul class="list-unstyled">
            <li>Java</li>
            <li>.NET</li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="white-section">
      <h2>WHY REGISTER <span>WITH JOBSHARK?</span></h2>
      <div class="row">
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDiv">
          <div class="info-box left">
            <div class="text">
              <h3>ACCESS TO EXCLUSIVE IT JOB OPPORTUNITIES</h3>
              <p>
                Gain entry to a curated selection of IT job openings from top companies and verified
                employers.
              </p>
            </div>
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-17.png`)" />
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDivRight">
          <div class="info-box right">
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-18.png`)" />
            </div>
            <div class="text">
              <h3>CHOOSE YOUR PREFERRED WORKING MODEL</h3>
              <p>
                We mediate freelancing opportunities and fully remote positions as well as
                traditional employment opportunities.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDiv">
          <div class="info-box left">
            <div class="text">
              <h3>PERSONAL SERVICES</h3>
              <p>
                Discover your perfect opportunities with Jobshark's personal services. Our dedicated
                HRs assist you in finding exactly the kind of roles that attracts you. Benefit from
                our personalized services and advisory support, ensuring your career journey is
                smooth and successful.
              </p>
            </div>
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-19.png`)" />
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDivRight">
          <div class="info-box right ">
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-20.png`)" />
            </div>
            <div class="text">
              <h3>EASY APPLICATION PROCESS</h3>
              <p>
                Enjoy a very easy application process. And if you don’t have a CV, don’t worry you
                can easily apply with your LinkedIn profile or similar.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDiv">
          <div class="info-box left">
            <div class="text">
              <h3>VERIFIED SERIOUS EMPLOYERS</h3>
              <p>
                Connect with great employers and unlock exciting job opportunities for career
                growth. Gain insights into work culture, and employer reputation to make informed
                career decisions.
              </p>
            </div>
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-21.png`)" />
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDivRight">
          <div class="info-box right">
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-22.png`)" />
            </div>
            <div class="text">
              <h3>MEANINGFUL PROJECTS</h3>
              <p>
                Discover opportunities with real social impact, contributing to causes that matter
                to you.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDiv">
          <div class="info-box left">
            <div class="text">
              <h3>FAST CAREER PROGRESSION</h3>
              <p>
                Find roles that propel your career forward and embrace rapid career growth.
              </p>
            </div>
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-23.png`)" />
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDivRight">
          <div class="info-box right">
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-24.png`)" />
            </div>
            <div class="text">
              <h3>WORK-LIFE BALANCE</h3>
              <p>
                Explore positions that prioritize work-life balance, enabling you to thrive both
                personally and professionally.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDiv">
          <div class="info-box left">
            <div class="text">
              <h3>SKILLS DEVELOPMENT</h3>
              <p>
                Access continuous learning and skills development opportunities to stay at the
                forefront of the IT industry.
              </p>
            </div>
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/runing.jpeg`)" />
            </div>
          </div>
        </div>
        <div class="col-md-9 mx-auto" v-observe-visibility="animateDivRight">
          <div class="info-box right">
            <div class="icon">
              <img :src="require(`../../../public/img/landing-pages/Icon-25.png`)" />
            </div>
            <div class="text">
              <h3>INSURANCE FOR YOUR FUTURE</h3>
              <p>
                Rest easy with our commitment to support and advocate for your career advancement.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gray-section">
      <h2>DON'T LET YOUR <span>DREAM IT JOB SLIP AWAY!</span></h2>
      <div class="row">
        <div class="col-md-9 mx-auto">
          <img
            class="image-responsive"
            :src="require(`../../../public/img/landing-pages/DONT-LET.jpg`)"
          />
          <div class="row">
            <div class="col-md-10 mx-auto">
              <p>
                Simply register with Jobshark and unleash unlock new possibilitiesy for you
                continued career development. Our platform connects you with top-rated companies
                offering exciting job opportunities that align perfectly with your skills and
                ambitions. With personalized job recommendations, our assistance and a seamless
                application process, <span>your dream job is just a few clicks away.</span>
              </p>
              <p>
                Join our thriving community of IT professionals and take the next step towards
                achieving your career goals. Embrace fast career progression, work-life balance, and
                skills development while contributing to projects that create a positive social
                impact and connect with like-minded professionals.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="black-section">
      <div class="col-md-7 mx-auto">
        <div class="d-flex items-center">
          <img :src="require(`../../../public/img/landing-pages/Icon-12.png`)" />
          <div class="text d-flex">
            <div>
              <p>
                MAKE THE MOST OUT OF YOUR PROFESSIONAL LIFE WITH JOBSHARK TODAY -
                <span>YOUR SUCCESS STORY BEGINS HERE!</span>
              </p>
              <button @click="openModal" id="register-btn" class="btn btn-secondary">
                SIGN ME UP!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomMainModal v-show="showModal" @close="closeModal">
      <template v-slot:header>
        <h5>{{ modalTitle }}</h5>
      </template>
      <Signin
        v-if="showLogin"
        @go-to-register="openModal"
        @go-to-reset-password="openModal"
      ></Signin>
      <div v-if="showModal">
        <Register
          v-show="showRegister && showModal"
          @go-to-login="openModal"
          @close="showModal = false"
          @set-email="email => (currentEmail = email)"
          @emailVerification="
            (openEmailVerification = true), (showRegister = false), (modalTitle = 'Verification')
          "
        />
      </div>

      <ResetPassword v-if="showResetPassword" @close="showModal = false" />
      <VerificationCode
        v-if="openEmailVerification"
        @prevStep="prevStep"
        :currentEmail="currentEmail.email"
      />
    </CustomMainModal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import IntersectionObserver from '@/components/common/IntersectionObserver';
import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import PublicNavigation from '../../components/Navigations/PublicNavigation';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import Signin from '@/components/Signin/Signin';
import Register from '@/components/Register/Register';
import ResetPassword from '../../components/ResetPassword/ResetPassword';
import VerificationCode from '@/components/SearchJob/VerificationCode';
import { BRANDS } from '../../constants';
import carousel from 'vue-owl-carousel';
Vue.directive('observe-visibility', ObserveVisibility);
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [titleMixin],
  title: 'Become part of the IT community | Jobshark',
  components: {
    IntersectionObserver,
    PublicNavigation,
    CustomMainModal,
    Signin,
    Register,
    ResetPassword,
    VerificationCode,
    carousel,
  },
  data: () => ({
    brands: BRANDS,
    inViewport: {
      now: false, // Is some part of the component currently in the viewport?
      fully: false, // Is the component completely in the viewport?
      above: false, // Is any part of the component above the viewport?
      below: false, // Is any part of the component below the viewport?
    },
    topCompetences: [],
    modalTitle: '',
    showModal: false,
    showResetPassword: false,
    showLogin: false,
    showRegister: false,
    openEmailVerification: false,
    currentEmail: '',
  }),
  methods: {
    closeModal() {
      (this.showModal = false), (this.showRegister = false);
      this.openEmailVerification = false;
    },
    prevStep() {
      this.showRegister = true;
      this.openEmailVerification = false;
      this.modalTitle = 'Register';
    },
    onLogout() {
      this.$router.push({ name: 'logout' });
    },
    /* onGoToMyProfile() {
      this.$router.push({ name: 'user-profile' });
    }, */
    openModal(e) {
      if (this.getAccType == 'admin') {
        this.$router.push({ name: `admin-jobs` });
      }

      if (this.getAccType == 'recruiter') {
        this.$router.push({ name: `recruiter-jobs` });
      }

      if (this.getAccType == 'manager') {
        this.$router.push({ name: `manager-profile` });
      }

      /*  if (this.getAccType == 'user') {
        this.$router.push({ name: `user-jobs` });
      } */

      if (this.getAccType == 'candidate') {
        this.$router.push({ name: `user-profile` });
      }

      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'register-btn') {
        this.modalTitle = 'Sign Up as Candidate';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Sign Up as Candidate';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    },
    animateDiv(isVisible, entry) {
      if (isVisible) {
        // trigger animation for the element
        let domElement = entry.target;
        domElement.classList.add('animate__animated', '');
      }
    },
    animateDivRight(isVisible, entry) {
      if (isVisible) {
        // trigger animation for the element
        let domElement = entry.target;
        domElement.classList.add('animate__animated', '');
      }
    },
    onIntersectionElement() {
      const colsList = Object.keys(this.$refs);

      colsList.forEach(item => {
        this.$refs[item][0].play();
      });
    },
    theFormat(number) {
      return number.toFixed(0);

      /* return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ','); */
    },
    completed() {
      //  console.log('Animation ends!');
    },
    playAnimation(col) {
      this.$refs[col].play();
    },
    getTopTenCompetences() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/competence/topcompetences`, {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.topCompetences = data.slice(0, -1);
        });
    },
  },
  computed: {
    ...mapGetters(['getAccType', 'isLoggedIn']),
  },
  mounted() {
    this.getTopTenCompetences();
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.brands {
  padding: 50px 0;

  h3 {
    text-transform: uppercase;
    text-align: center;
    font-size: 34px;
    margin-bottom: 50px;
  }
  img {
    filter: grayscale(100%);
    &:hover {
      filter: grayscale(0);
    }
  }
}
.statistics {
  padding: 60px 0 60px 0;

  h2 {
    margin-bottom: 30px;
  }

  .list-inline {
    margin: 0;
    font-family: $font-family-sans-lato;
    flex-wrap: wrap;

    li {
      width: 20%;
      text-align: center;
      font-size: 16px;
      border: 1px solid rgba(0, 0, 0, 0.02);
      width: 105px;
      height: 105px;
      color: #888;
      border-radius: 6px;
      -webkit-box-shadow: 0px 15px 35px #0000000d;
      box-shadow: 0px 15px 35px #0000000d;
      background: #fff;

      .text {
        width: 100%;

        span {
          display: block;
          margin: 4px auto;
          font-weight: 700;
          color: #575757;
        }

        i {
          display: block;
          font-size: 41px;
        }

        img {
          width: 42px;
          height: 42px;
        }
      }
    }
  }
}
.landing-page-employers {
  .main-header {
    position: relative;
    min-height: 100vh;
    background: url('../../../public/img/landing-pages/Header_Candidates.jpg');
    background-size: cover;
    margin: 0;
    .center-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        text-align: center;
        width: 460px;
        padding-top: 100px;
        img {
          width: 180px;
          height: 180px;
        }
        h1 {
          font-size: 2.1rem;
          font-weight: 900;
        }
      }
    }
  }

  .content-section-gray {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    background-color: #ebeced;
    .content {
      padding: 40px 120px;
      h2 {
        font-size: 36px;
        font-weight: 500;
        text-align: center;
        span {
          font-weight: 600;
          display: block;
        }
      }
      .orange {
        display: block;
        color: #f26622;
        font-size: 36px;
        text-align: center;
        margin-top: 50px;
        line-height: 1.2;
        span {
          display: block;
        }
      }
      .btn-secondary {
        margin-top: 80px;
        font-size: 21px;
        padding: 6px 75px;
      }
    }
  }
  .stats {
    padding: 80px 0;
    background: #eef7fb;
    .d-flex {
      justify-content: space-evenly;
    }
    .info-col {
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      width: 15%;
      padding: 20px 12px;
      span {
        display: block;
        margin-bottom: 5px;
        font-size: 34px;
      }
      h2 {
        font-weight: 900;
        font-size: 21px;
        span {
          display: block;
          font-size: 21px;
        }
      }
      .list-unstyled {
        li {
          font-size: 14px;
          color: #666;
        }
      }
      &:nth-child(even) {
        color: #08c;
      }
      &:nth-child(odd) {
        color: #f26622;
      }
      &:last-of-type {
        border: none;
      }
    }
  }
  .white-section {
    padding: 80px 120px;
    h2 {
      font-weight: 900;
      text-align: center;
      margin-bottom: 50px;
      span {
        display: block;
      }
    }
    .info-box {
      display: flex;
      align-items: center;
      border-radius: 22px;
      padding: 20px 80px;
      min-height: 300px;
      max-height: auto;
      margin-bottom: 20px;
      .text {
        width: 60%;
        h3 {
          margin-bottom: 20px;
        }
        p {
          font-weight: 500;
          color: #555;
          font-size: 21px;
        }
      }
      .icon {
        width: 200px;
        height: 200px;
        img {
          width: 200px;
          height: 200px;
          object-fit: cover;
        }
      }
      &.left {
        background: linear-gradient(to right, #f1f1f1, transparent);
        .icon {
          margin-left: auto;
        }
      }
      &.right {
        background: linear-gradient(to left, #f1f1f1, transparent);
        .icon {
          margin-right: auto;
        }
      }
    }
  }

  .gray-section {
    background: #f9f9f9;
    padding: 120px;
    h2 {
      font-weight: 900;
      text-align: center;
      margin-bottom: 50px;
      span {
        display: block;
      }
    }
    .image-responsive {
      width: 100%;
      display: block;
      height: auto;
      margin-bottom: 50px;
    }
    p {
      font-size: 21px;
      font-weight: 500;
      span {
        font-weight: 600;
        color: #f26622;
      }
    }
  }
  .black-section {
    height: 360px;
    background: #222325;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 200px;
      height: auto;
      margin-right: 40px;
      flex-shrink: 0;
    }
    .text {
      text-align: right;
      align-items: center;
      p {
        font-size: 24px;
        span {
          display: block;
          color: #f26622;
        }
      }
      .btn-secondary {
        padding: 8px 55px;
        text-transform: uppercase;
        font-weight: 600;
      }
    }
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .statistics {
    .list-inline {
      li {
        margin: 0 0 12px 0;
      }
    }
  }
  .landing-page-employers {
    .main-header {
      min-height: 50vh;
      background-position: center;
      background-size: 1000px;

      .center-text {
        .text {
          padding-top: 0;
          padding-bottom: 20px;
          h1 {
            padding: 0 100px;
            font-size: 1.1rem;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
  }
  .landing-page-employers {
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
        .orange {
          font-size: 26px;
        }
      }
    }

    .content-section-white {
      .content {
        h3 {
          font-size: 32px;
        }
      }
      .info-box {
        margin: 25px auto;

        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .white-section {
      padding: 20px 0;
      .info-box {
        position: relative;
        display: block;
        height: auto;
        padding: 25px;
        margin: 15px;
        .text {
          width: 100%;
          h3 {
            font-size: 21px;
          }
          p {
            font-size: 18px;
          }
        }
        .icon {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 12px;
          opacity: 0.2;
        }
        &.left {
          background: linear-gradient(to right, #f6f6f6, transparent);
        }
        &.right {
          background: linear-gradient(to left, #f6f6f6, transparent);
        }
      }
    }
    .gray-section {
      padding: 30px 12px;
      h2 {
        font-size: 1.2rem;
      }
      p {
        font-size: 18px;
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 601px) and (max-width: 768px) {
  .statistics {
    .list-inline {
      li {
        margin: 0 0 12px 0;
      }
    }
  }
  .landing-page-employers {
    .main-header {
      min-height: 65vh;
      background-position: center;
      background-size: 1000px;

      .center-text {
        .text {
          padding-top: 0;
          padding-bottom: 20px;
          h1 {
            padding: 0 100px;
            font-size: 1.4rem;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
  }
  .landing-page-employers {
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
        .orange {
          font-size: 26px;
        }
      }
    }

    .content-section-white {
      .content {
        h3 {
          font-size: 32px;
        }
      }
      .info-box {
        margin: 25px auto;

        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .white-section {
      padding: 20px 0;
      .info-box {
        position: relative;
        display: block;
        height: auto;
        padding: 25px;
        margin: 15px;
        .text {
          width: 100%;
          h3 {
            font-size: 21px;
          }
          p {
            font-size: 18px;
          }
        }
        .icon {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 12px;
          opacity: 0.2;
        }
        &.left {
          background: linear-gradient(to right, #f6f6f6, transparent);
        }
        &.right {
          background: linear-gradient(to left, #f6f6f6, transparent);
        }
      }
    }
    .gray-section {
      padding: 30px 12px;
      h2 {
        font-size: 1.2rem;
      }
      p {
        font-size: 18px;
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Medium devices (landscape tablets, 769px and up) */
@media only screen and (min-width: 769px) and (max-width: 992px) {
  .statistics {
    .list-inline {
      li {
        margin: 0 0 12px 0;
      }
    }
  }
  .landing-page-employers {
    .main-header {
      min-height: 70vh;
      background-position: center;
      background-size: 1000px;

      .center-text {
        .text {
          padding-top: 0;
          padding-bottom: 20px;
          h1 {
            padding: 0 100px;
            font-size: 1.5rem;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
  }
  .landing-page-employers {
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            margin: 30px auto;
          }
        }
        .orange {
          font-size: 26px;
        }
      }
    }

    .content-section-white {
      .content {
        h3 {
          font-size: 32px;
        }
      }
      .info-box {
        margin: 25px auto;

        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .white-section {
      padding: 20px 0;
      .info-box {
        position: relative;
        display: block;
        height: auto;
        padding: 25px;
        margin: 15px;
        .text {
          width: 100%;
          h3 {
            font-size: 21px;
          }
          p {
            font-size: 18px;
          }
        }
        .icon {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 12px;
          opacity: 0.2;
        }
        &.left {
          background: linear-gradient(to right, #f6f6f6, transparent);
        }
        &.right {
          background: linear-gradient(to left, #f6f6f6, transparent);
        }
      }
    }
    .gray-section {
      padding: 30px 12px;
      h2 {
        font-size: 1.2rem;
      }
      p {
        font-size: 18px;
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Large devices (laptops/desktops, 993px and up) */
@media only screen and (min-width: 993px) and (max-width: 1200px) {
  .statistics {
    .list-inline {
      li {
        margin: 0 0 12px 0;
      }
    }
  }
  .landing-page-employers {
    .main-header {
      min-height: 50vh;
      background-position: center;
      background-size: 1000px;

      .center-text {
        .text {
          padding-top: 0;
          padding-bottom: 20px;
          h1 {
            padding: 0 100px;
            font-size: 1.1rem;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
  }
  .landing-page-employers {
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
        .orange {
          font-size: 26px;
        }
      }
    }

    .content-section-white {
      .content {
        h3 {
          font-size: 32px;
        }
      }
      .info-box {
        margin: 25px auto;

        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .white-section {
      padding: 20px 0;
      .info-box {
        position: relative;
        display: block;
        height: auto;
        padding: 25px;
        margin: 15px;
        .text {
          width: 100%;
          h3 {
            font-size: 21px;
          }
          p {
            font-size: 18px;
          }
        }
        .icon {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 12px;
          opacity: 0.2;
        }
        &.left {
          background: linear-gradient(to right, #f6f6f6, transparent);
        }
        &.right {
          background: linear-gradient(to left, #f6f6f6, transparent);
        }
      }
    }
    .gray-section {
      padding: 30px 12px;
      h2 {
        font-size: 1.2rem;
      }
      p {
        font-size: 18px;
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Extra large devices (large laptops and desktops, 1201px and up) */
@media only screen and (min-width: 1201px) {
  /* Your styles here */
}
</style>
